import { Box, Grid, Typography } from '@mui/material';
// import Image from 'next/image';

export type MemberType = {
  name?: string;
  image: any;
  designation?: string;
  href?: string;
};

export const MemberCard = ({ name, image, designation, href }: MemberType) => {
  return (
    <Grid
      item
      sx={{ display: 'flex', flexDirection: 'column', px: 0 }}
      lg={3}
      md={4}
      sm={4}
      xs={6}
      p={3}
    >
      <Box
        height={180}
        width={180}
        display="flex"
        alignItems="flex-start"
        justifyContent="center"
        maxWidth="100%"
        p={0}
        sx={{
          backgroundColor: 'rgba(244, 255, 252, 1)',
          borderRadius: '10px',
          '& img': {
            maxWidth: '100%',
            // ml: 'auto',
          },
          margin: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
        }}
      >
        {href ? (
          <a href={href}>
            <img alt={name} src={image.src} />
          </a>
        ) : (
          <img alt={name} src={image.src} />
        )}
      </Box>
      <Typography color="#111" fontSize={16} pt={2} align="center">
        {name}
      </Typography>
      <Typography
        color="rgba(17, 17, 17, 0.5)"
        fontSize={14}
        lineHeight={1}
        align="center"
      >
        {designation}
      </Typography>
    </Grid>
  );
};
